export const mapDebtorsResponseToReduxStore = (documentsArray = []) =>
  documentsArray.map((item) => ({
    clientName: item.accountName,
    clientId: item.accountCode,
    remainingAmount: item.debt,
  }));
